import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
  { field: 'id', headerName: 'S.NO', width: 90 },
  {
    field: 'requestId',
    headerName: 'Request Id',
    width: 150,
    editable: false,
  },
  {
    field: 'agentcode',
    headerName: 'Agent Code',
    width: 150,
    editable: false,
  },
  {
    field: 'agentname',
    headerName: 'Agent Name',
    width: 200,
    editable: false,
  },
  {
    field: 'mobile',
    headerName: 'Mobile',
    width: 200,
    editable: false,
  },
  {
    field: 'state',
    headerName: 'State',
    width: 200,
    editable: false,
  },
  {
    field: 'district',
    headerName: 'District',
    width: 200,
    editable: false,
  },
  {
    field: 'requestdate',
    headerName: 'Request Date',
    width: 200,
    editable: false,
  },
  {
    field: 'topupamount',
    headerName: 'Top Up Amount',
    width: 200,
    editable: false,
  },
  {
    field: 'topuptype',
    headerName: 'Top Up Type',
    width: 200,
    editable: false,
  },
  {
    field: 'bankname',
    headerName: 'Bank Name',
    width: 200,
    editable: false,
  },
  {
    field: 'transferdate',
    headerName: 'Transfer Date',
    width: 200,
    editable: false,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 200,
    editable: false,
  },
  {
    field: 'reason',
    headerName: 'Reason',
    width: 200,
    editable: false,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    width: 200,
    editable: false,
  },
  
];

const rows = [
  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 14 },
  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 31 },
  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 31 },
  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 11 },
  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];

export default function StatusGrid() {
  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        
        disableRowSelectionOnClick
        editMode={false}
      />
    </Box>
  );
}
